import styled from "styled-components";
import Row from "../../../Shared/Kit/Row";
import Col from "../../../Shared/Kit/Col";
import { HexToRgba } from "../../../Methods/HexToRgba";

export const SliderContainer = styled(Col)`
border: solid;
    width: 100vw;
    height: 100vh;
`
export const Container = styled(Col)`
    margin: auto;
    padding-bottom: 100px;
`
export const Title = styled(Row)`
    font-size: 48px;
    font-weight: bold;
    color:  ${(props) => props.theme.white};
`

export const Description = styled(Row)`
    font-size: ${(props) => props.theme.fontSizeSm};
    color:  ${(props) => HexToRgba(props.theme.white, 0.8)};
    margin-top: 8px;
    .line {
        width: 16px;
        height: 1px;
        background-color:  ${(props) => HexToRgba(props.theme.white, 0.2)};
        margin-left: 10px;
    }
`